// 3rd Party & Native
import { AgmCoreModule } from 'angular2-google-maps/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppVersion } from '@ionic-native/app-version';
import { CalendarModule } from 'ion2-calendar';
import { Camera } from '@ionic-native/camera';
import { Crop } from '@ionic-native/crop';
import { File } from '@ionic-native/file';
import { Network } from '@ionic-native/network';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MomentModule } from 'angular2-moment';
import { PapaParseModule } from 'ngx-papaparse';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TextMaskModule } from 'angular2-text-mask';
import { HttpClient, HttpHandler, HttpBackend, HttpClientModule } from '@angular/common/http';



// Components
import { ActivityMenuComponent } from '../components/activity-menu/activity-menu';
import { LogMenuComponent } from '../components/log-menu/log-menu';
import { ChooseActiveCompany } from '../components/choose-active-company/choose-active-company';
import { ChooseActiveProjectPage } from '../components/choose-active-project/choose-active-project';
import { LoginComponent } from "../pages/auth/login/login.component";
import { RegisterComponent } from "../pages/auth/register/register.component";
import { ConfirmRegistrationComponent } from "../pages/auth/confirm-registration/confirmRegistration.component";
import { ResendCodeComponent } from "../pages/auth/resend-code/resendCode.component";
import { ForgotPasswordStep1Component } from "../pages/auth/forgot-password/forgotPassword1.component";
import { ForgotPasswordStep2Component } from "../pages/auth/forgot-password/forgotPassword2.component";
import { LogoutComponent } from "../pages/auth/logout.component";
import { HTTP } from '@ionic-native/http/ngx';


// Services
import { EmailLoginService } from '../services/email_login';
import { PictureService } from '../services/picture';
import { SharedService } from '../services/sharedService';
import { AuthServiceProvider } from '../services/auth.service';
import { HttpService } from '../services/httpService';
import { CompanyService } from '../services/companyData';
import { ProjectService } from '../services/projectData';

// Directives
import { FilterMenuComponent, FilterMenuModal } from '../directives/filter_menu/filter_menu.component';
import { ActionBarHeader } from '../directives/action_bar_header/action_bar_header.component';
import { ActivityOverview } from '../directives/activity_overview/activity_overview.component';
import { SideMenu } from '../directives/side_menu/side_menu.component';
import { ToastProvider } from '../directives/toast/toast';

// Providers
import { UserLoginService } from "../providers/userLogin.service";
import { UserParametersService } from "../providers/userParameters.service";
import { UserRegistrationService } from "../providers/userRegistration.service";
import { CognitoUtil } from "../providers/cognito.service";
import { AuthenticationService } from "../services/congito"
import { AwsUtil } from "../providers/aws.service";
import { EventsService } from "../providers/events.service";


// Pages
import { NewProjectComponent } from '../pages/new-project/new-project';
import { SelectProjectManagerComponent } from '../pages/select-project-manager/select-project-manager';
import { AddProjectUserComponent } from '../pages/add-project-user/add-project-user';
import { ProjectHomePage } from '../pages/project-home/project-home';
import { ProjectDetailTabsPage } from '../pages/project-detail-tabs/project-detail-tabs';
import { ProjectInfo } from '../pages/project-info/project-info';
import { ProjectUsers } from '../pages/project-users/project-users';
import { EditProjectInfoComponent } from '../pages/edit-project-info/edit-project-info';
import { LogView } from '../pages/log-view/log-view';
import { LogsPage } from '../pages/logs/logs';
import { ActivityLogsPage } from '../pages/activity-logs/activity-logs';
import { NewLogComponent } from '../pages/new-log/new-log';
import { HelpModalComponent } from '../pages/help-modal/help-modal';
import { AllCompaniesPage } from '../pages/all-companies/all-companies';
import { NewCompanyPage } from '../pages/new-company/new-company';
import { AddCompanyUserPage } from '../pages/add-company-user/add-company-user';
import { LogActivityDetailsPage } from '../pages/log-activity-details/log-activity-details';
import { LogUsersPage } from '../pages/log-users/log-users';
import { AddLogUserPage } from '../pages/add-log-user/add-log-user';
import { CompanyPage } from '../pages/company/company';
import { CompanyInfoTab } from '../pages/company-info-tab/company-info-tab';
import { CompanyUsersTab } from '../pages/company-users-tab/company-users-tab';
import { CompanyProjectsTab } from '../pages/company-projects-tab/company-projects-tab';
import { EditCompanyInfoComponent } from '../pages/edit-company-info/edit-company-info';
import { NewUpdateComponent } from '../pages/new-update/new-update';
import { CurrentUpdate } from '../pages/current-update/current-update';
import { ArchivedUpdates } from '../pages/archived-updates/archived-updates';
import { UserProfilePage } from '../pages/user-profile/user-profile';
import { LogMessagesPage } from '../pages/log-messages/log-messages';
import { LogPhotosPage } from '../pages/log-photos/log-photos';
import { ShowPictureComponent } from '../pages/show-picture/show-picture';
import { ActivityListPage } from '../pages/activities/activities';
import { ActivityDetailsPage } from '../pages/activity-details/activity-details';
import { SupportComponent } from '../pages/support/support';
// import { ForgotPasswordPage } from '../auth/pages/forgot-password/forgot-password';


// Routes
import { RoutesModule } from './routes.module';
import { ActivityService } from '../services/activityData';


// Logging & Insights
// import AtatusErrorHandler from './atatus.handler';


@NgModule({
  imports: [
    
    MomentModule,
    IonicModule,
    BrowserModule,
    HttpClientModule,
    HttpModule,
    CalendarModule,
    TextMaskModule,
    PapaParseModule,
    RoundProgressModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAWoBdZHCNh5R-hB5S5ZZ2oeoYyfdDgniA'
    }),
    IonicModule.forRoot(ProjectHomePage),
    IonicModule.forRoot(ActivityDetailsPage),
    IonicModule.forRoot(LogsPage),
    IonicModule.forRoot(ActivityLogsPage),
    IonicModule.forRoot(LogUsersPage),
    IonicModule.forRoot(AddLogUserPage),
    IonicModule.forRoot(NewLogComponent),
    IonicModule.forRoot(HelpModalComponent),
    IonicModule.forRoot(LogView),
    IonicModule.forRoot(LogMessagesPage),
    IonicModule.forRoot(LogPhotosPage),
    IonicModule.forRoot(ShowPictureComponent),
    IonicModule.forRoot(ActivityMenuComponent),
    IonicModule.forRoot(LogMenuComponent),
    IonicModule.forRoot(LogActivityDetailsPage),
    IonicModule.forRoot(AddProjectUserComponent),
    IonicModule.forRoot(AllCompaniesPage),
    IonicModule.forRoot(AddCompanyUserPage),
    IonicModule.forRoot(LoginComponent),
    IonicModule.forRoot(LogoutComponent),
    IonicModule.forRoot(RegisterComponent),
    IonicModule.forRoot(ConfirmRegistrationComponent),
    IonicModule.forRoot(ResendCodeComponent),
    IonicModule.forRoot(ForgotPasswordStep1Component),
    IonicModule.forRoot(ForgotPasswordStep2Component),
    IonicModule.forRoot(UserProfilePage),
    IonicModule.forRoot(ProjectDetailTabsPage),
    IonicModule.forRoot(EditProjectInfoComponent),
    IonicModule.forRoot(NewUpdateComponent),
    IonicModule.forRoot(NewProjectComponent),
    IonicModule.forRoot(SelectProjectManagerComponent),
    IonicModule.forRoot(ChooseActiveProjectPage),
    IonicModule.forRoot(ChooseActiveCompany),
    IonicModule.forRoot(NewCompanyPage),
    IonicModule.forRoot(FilterMenuComponent),
    IonicModule.forRoot(FilterMenuModal),
    IonicModule.forRoot(ActionBarHeader),
    IonicModule.forRoot(ActivityOverview),
    IonicModule.forRoot(SideMenu),
    IonicModule.forRoot(ProjectInfo),
    IonicModule.forRoot(ProjectUsers),
    IonicModule.forRoot(CurrentUpdate),
    IonicModule.forRoot(ArchivedUpdates),
    IonicModule.forRoot(CompanyPage),
    IonicModule.forRoot(CompanyInfoTab),
    IonicModule.forRoot(EditCompanyInfoComponent),
    IonicModule.forRoot(CompanyUsersTab),
    IonicModule.forRoot(CompanyProjectsTab),
    IonicModule.forRoot(SupportComponent),
    IonicModule.forRoot(ActivityListPage),
    // Routes
    RoutesModule,
  ],
  declarations: [
    ProjectHomePage,
    ActivityDetailsPage,
    ActivityMenuComponent,
    LogMenuComponent,
    LogsPage,
    ActivityLogsPage,
    LogUsersPage,
    AddLogUserPage,
    NewLogComponent,
    HelpModalComponent,
    LogView,
    LogMessagesPage,
    LogPhotosPage,
    ShowPictureComponent,
    LogActivityDetailsPage,
    AddProjectUserComponent,
    AllCompaniesPage,
    AddCompanyUserPage,
    UserProfilePage,
    ProjectDetailTabsPage,
    EditProjectInfoComponent,
    SupportComponent,
    NewUpdateComponent,
    NewProjectComponent,
    SelectProjectManagerComponent,
    ChooseActiveProjectPage,
    ChooseActiveCompany,
    NewCompanyPage,
    FilterMenuComponent,
    FilterMenuModal,
    ActionBarHeader,
    ActivityOverview,
    SideMenu,
    ProjectInfo,
    ProjectUsers,
    CurrentUpdate,
    ArchivedUpdates,
    CompanyPage,
    CompanyInfoTab,
    EditCompanyInfoComponent,
    CompanyUsersTab,
    CompanyProjectsTab,
    ActivityListPage,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ConfirmRegistrationComponent,
    ResendCodeComponent,
    ForgotPasswordStep1Component,
    ForgotPasswordStep2Component,

  ],
  exports: [
    ProjectHomePage,
    ActivityDetailsPage,
    LogsPage,
    ActivityLogsPage,
    LogUsersPage,
    AddLogUserPage,
    NewLogComponent,
    HelpModalComponent,
    ActivityMenuComponent,
    LogMenuComponent,
    LogView,
    LogMessagesPage,
    LogPhotosPage,
    ShowPictureComponent,
    LogActivityDetailsPage,
    AddProjectUserComponent,
    AllCompaniesPage,
    AddCompanyUserPage,
    SupportComponent,
    UserProfilePage,
    ProjectDetailTabsPage,
    EditProjectInfoComponent,
    NewUpdateComponent,
    NewProjectComponent,
    SelectProjectManagerComponent,
    ChooseActiveProjectPage,
    ChooseActiveCompany,
    NewCompanyPage,
    FilterMenuComponent,
    FilterMenuModal,
    ActionBarHeader,
    ActivityOverview,
    SideMenu,
    ProjectInfo,
    ProjectUsers,
    CurrentUpdate,
    ArchivedUpdates,
    CompanyPage,
    CompanyInfoTab,
    EditCompanyInfoComponent,
    CompanyUsersTab,
    CompanyProjectsTab,
    ActivityListPage,
  ],
  providers: [
   {provide: ErrorHandler, useClass: IonicErrorHandler},
    StatusBar,
    SplashScreen,
    EmailLoginService,
    PictureService,
    AuthenticationService,
    SharedService,
    Camera,
    File,
    Crop,
    Network,
    OpenNativeSettings,
    AppVersion,
    AuthServiceProvider,
    ToastProvider,
    CognitoUtil,
    AwsUtil,
    UserLoginService,
    UserParametersService,
    UserRegistrationService,
    EventsService,
    ProjectService,
    CompanyService,
    HttpService,
    HttpClient,
    ActivityService,
    // HttpHandler,
    // HttpBackend,
    HTTP
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared.module.ts